import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';
import { InAppBrowser, InAppBrowserOptions, InAppBrowserObject } from '@ionic-native/in-app-browser';
import { Events } from 'ionic-angular';

@Injectable()
export class BillingPaymentsProvider {

	paymentURL = environment.paymentUrl;
  ismURL = environment.ismUrl;
  public billTypesMap : Map<any, any> = new Map<any, any>();

  constructor(public http: HttpClient,
    private storage :Storage,
    public events: Events,
    private inAppBrowser:InAppBrowser) {}

  getBillings(){
  	return this.getToken().then((val) => {
      if(val){
        return this.http.get<any>(this.getUrl(this.ismURL, `/getBillsByFlat/${val.flat_no}`,val))
        .toPromise();
      }
    });
  }

  getBillTypeName(id){
    let data = this.billTypesMap.get(id);
    if(data && data.name){
      return data.name;
    }else{
      return "Balance";
    }
  }

  getBillTypeObj(id){
    let data = this.billTypesMap.get(id);
    if(data && data.name){
      return data;
    }else{
      return {
        name: "Balance"
      };
    }
  }

  getBillTypes(refresh = false){
    return this.getToken().then((val) => {
      if(this.billTypesMap.size > 0 && !refresh){
        return Promise.resolve(this.billTypesMap);
      }
      if(val){
        return this.http.get<any>(this.getUrl(this.ismURL, `/getBillType/${val.societyId}`,val)).toPromise().then(val => {
          this.billTypesMap.clear();
          if(val.status == "success" && val.data){
            val.data.forEach(val => {
              this.billTypesMap.set(val.id, val);
            });
          }else{
            this.billTypesMap.set(0, {
              id: 0,
              name: "Balance"
            });
          }
          return Promise.resolve(this.billTypesMap);
        });
      }
    });
  }

  getAccountStatement(id: string, pageNo: number){
    return this.getToken().then((val) => {
      if(val){
        let url = this.getUrl(this.ismURL, `/billing/houseStatement/${val.id}/${pageNo}/100`,val);
        if(id != "0"){
          url = url + `&bill_type=${id}`;
        }
        return this.http.get<Response>(url)
        .toPromise();
      }
    });
  }

  getPayments(status: string){
    let url;

    return this.getToken().then((val) => {
      if(val){
        if(status == "DEBIT-CREDIT"){
          url = this.getUrl(this.paymentURL, `/v1/society/${val.societyId}/getpayments`,val)+`&flat_no_x=${val.flat_no}&types[]=DEBIT&types[]=CREDIT`;
        }else if(status){
          url = this.getUrl(this.paymentURL, `/v1/society/${val.societyId}/getpayments`,val)+`&flat_no_x=${val.flat_no}&status=${status}`;
        }else{ 
          url = this.getUrl(this.paymentURL, `/v1/society/${val.societyId}/getpayments`,val)+`&flat_no_x=${val.flat_no}`;
        }
        return this.http.get<Response>(url)
        .toPromise();
      }
    });
  }

  getOutstandings(cache: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.ismURL, `/my/outstandingbalances`,val)+`&cache=${cache}`)
        .toPromise();
      }
    });
  }

  getOutstandingBalance(billType: string){
    return this.getToken().then((val) => {
      if(val){
        if(billType == "0"){
          billType = "";
        }
        return this.http.get<Response>(this.getUrl(this.ismURL, `/getOutstandingBalance/${val.id}`,val) + `&cache=0&bill_type=${billType}`)
        .toPromise();
      }
    });
  }

  getBillReportData(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(this.ismURL, `/getUserBillReportByDates`,val), {
          userId: val.id
        })
        .toPromise();
      }
    });
  }

  getPaymentDetail(id: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.paymentURL, `/v1/society/${val.societyId}/getpayments`,val)+`&id=${id}`)
        .toPromise();
      }
    });
  }

  validateRecharge(amount: number, id: number){
    return this.getToken().then((val) => {
      if(val){
        let params = `&amount=${amount}&society_id=${val.societyId}&bill_type=${id}&user_id=${val.id}`;
        return this.http.get<Response>(this.getUrl(this.paymentURL, `/v1/society/${val.societyId}/validaterecharge`,val)+params)
        .toPromise();
      }
    });
  }
  options : InAppBrowserOptions = {
    hidenavigationbuttons : 'yes',
    footer : 'yes',
    location : 'no',//Or 'no' 
    hidden : 'no', //Or  'yes'
    clearcache : 'yes',
    clearsessioncache : 'yes',
    zoom : 'no',//Android only ,shows browser zoom controls 
    hardwareback : 'no',
    mediaPlaybackRequiresUserAction : 'no',
    shouldPauseOnSuspend : 'no', //Android only 
    closebuttoncaption : 'Done', //iOS only
    disallowoverscroll : 'no', //iOS only 
    toolbar : 'yes', //iOS only 
    enableViewportScale : 'no', //iOS only 
    allowInlineMediaPlayback : 'no',//iOS only 
    presentationstyle : 'pagesheet',//iOS only 
    fullscreen : 'yes',//Windows only  
  };
  openExternalInAppBrowser(url : string){
    let target = "_system";
    let browser = this.inAppBrowser.create(url,target,this.options);
  }
  openWithInAppBrowser(url : string){
    let target = "_blank";
    var browser = this.inAppBrowser.create(url,target,this.options);
    var selfObj =  this;
    browser.on('exit').subscribe( (obj)=>{
      try{
        this.events.publish('payment-browser:exit', obj);
        let action = localStorage.getItem("action");
        if(action){
          localStorage.removeItem("action");
          selfObj.openExternalInAppBrowser(action);
        }
      }catch(e){
        console.log(e);
      }
    })
    browser.on('loadstop').subscribe((event) =>{
      console.log("loadstop: ", event);
      let count = 0;
      let poll = setInterval(function() {
        if(count === 0){
          browser.executeScript({code:'localStorage.removeItem("action");window.onSelectPaymentOption = function onSelectPaymentOption(action){localStorage.setItem("action", action);};'}).then((result)=>{
          }) 
          count++
        }
          browser.executeScript({code:'let actionValue = null;actionValue = localStorage.getItem("action");'}).then((result)=>{
            if(result && result.length > 0 && result[0]){    
              // console.log("On click external url:", result)                   
              localStorage.setItem("action",result[0]);
              clearInterval(poll)
              browser.close() 
            }
          });
      }, 500)
    });
  }


  makePayment(amount: number, billType = null, remarks: string = ""){
    this.getToken().then((val) => {
      if(val){
        let url = this.getUrl(this.paymentURL,`/v1/society/${val.societyId}/requestpayment`,val) + 
        `&sub_domain=`+environment.subDomain+
        `&flat_no=${val.flat_no}` +
        `&amount=${amount}`+
        `&remarks=${remarks}`;
        if(billType && billType != 0){
          if(billType.id == 'AMENITY_BOOKING'){
            url = url + `&bill_type=null&amenity=`+billType.amenity.booking_id;            
          }else{
            url = url + `&bill_type=${billType}`;
          }
          
        }
        console.log(url);
        this.openWithInAppBrowser(url);
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(url:string, link: string, val: any):string {
    return `${url}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}



// WEBPACK FOOTER //
// ./src/providers/billing-payments/billing-payments.ts